//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storageListSaveApi } from '@/api/administration';
export default {
  name: 'AddMaterial',
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    var checkNumber = function checkNumber(rule, value, callback) {
      if (!value && !_this.formData.edit) {
        return callback(new Error('请输入入库数量'));
      } else {
        callback();
      }
    };
    var checkPrice = function checkPrice(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入单价'));
      } else {
        callback();
      }
    };
    return {
      drawer: false,
      direction: 'rtl',
      rules: {
        name: '',
        cid: [],
        units: '',
        specs: '',
        factory: '',
        mark: '',
        price: undefined,
        number: undefined,
        remark: '',
        types: null
      },
      loading: false,
      itemData: {},
      rule: {
        name: [{
          required: true,
          message: '请选择(输入)物资名称',
          trigger: 'change,blur'
        }],
        cid: [{
          required: true,
          message: '请选择物资分类',
          trigger: 'change'
        }],
        number: [{
          required: true,
          validator: checkNumber,
          trigger: 'blur'
        }],
        price: [{
          required: true,
          validator: checkPrice,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    formData: {
      handler: function handler(nVal) {
        if (nVal.edit) {
          this.rules.name = nVal.data.name;
          this.rules.cid = nVal.data.cid;
          this.rules.units = nVal.data.units;
          this.rules.specs = nVal.data.specs;
          this.rules.factory = nVal.data.factory;
          this.rules.mark = nVal.data.mark;
          this.rules.number = 0;
          if (nVal.type === 1) {
            this.rules.price = nVal.data.record[0].price;
          }
        } else {
          this.countriesSelect();
        }
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.drawer = false;
      this.reset();
    },
    openBox: function openBox() {
      this.drawer = true;
    },
    reset: function reset() {
      this.rules = {
        name: '',
        cid: '',
        units: '',
        specs: '',
        factory: '',
        mark: '',
        price: undefined,
        number: undefined,
        remark: '',
        types: null
      };
    },
    // 提交
    handleConfirm: function handleConfirm() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.rules.types = _this2.formData.type;
          if (_this2.formData.edit) {
            if (_this2.rules.cid.length > 1) {
              _this2.rules.cid = _this2.rules.cid[_this2.rules.cid.length - 1];
            }
            _this2.rules.id = _this2.formData.data.id;
            _this2.storageSave(_this2.rules, true);
          } else {
            // 添加
            if (typeof _this2.rules.name === 'string') {
              _this2.rules.cid = _this2.rules.cid[_this2.rules.cid.length - 1];
              _this2.storageSave(_this2.rules);
            } else {
              _this2.rules.cid = _this2.rules.cid[_this2.rules.cid.length - 1];
              _this2.rules.name = _this2.itemData.name;
              if (_this2.getJudgeInfo()) {
                // 无任何变化时修改
                if (_this2.rules.types !== 1) {
                  _this2.rules.id = _this2.itemData.id;
                }
                _this2.storageSave(_this2.rules);
              } else {
                _this2.storageSave(_this2.rules);
              }
            }
          }
        }
      });
    },
    // 保存物资
    storageSave: function storageSave(data) {
      var _this3 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.loading = true;
      storageListSaveApi(data).then(function (res) {
        _this3.handleClose();
        _this3.$emit('isOk');
        _this3.reset();
        _this3.loading = false;
        var message = '';
        if (type) {
          message = '修改成功';
        } else {
          if (_this3.formData.type === 1) {
            message = '';
            if (res.data) {
              var len = res.data.length;
              if (len > 1) {
                message = '编号为 ' + res.data[0] + ' -- ' + res.data[len - 1] + ' 的物资添加成功';
              } else {
                message = '编号为 ' + res.data[0] + ' 的物资添加成功';
              }
            }
          } else {
            message = '添加成功';
          }
        }
      }).catch(function (error) {
        _this3.loading = false;
      });
    },
    handleName: function handleName(e) {
      if (typeof e === 'string') {
        // this.rules.cid = ''
        // this.rules.units = ''
        // this.rules.specs = ''
        // this.rules.factory = ''
        // this.rules.mark = ''
        // this.rules.number = undefined
        // this.rules.price = undefined
      } else {
        var data = this.formData.selectData[e];
        this.itemData = data;
        this.rules.cid = data.cate.path;
        if (this.rules.cid.length > 0) {
          if (!this.rules.cid.includes(data.cid)) {
            this.rules.cid.push(data.cid); // 添加当前分类
          }
        } else {
          this.rules.cid.unshift(0);
          this.rules.cid.push(data.cid);
        }
        this.rules.units = data.units;
        this.rules.specs = data.specs;
        this.rules.factory = data.factory;
        this.rules.mark = data.mark;
        this.rules.number = undefined;
        this.rules.price = undefined;
      }
    },
    countriesSelect: function countriesSelect() {
      var _this4 = this;
      this.$nextTick(function () {
        var countriesSelect = document.querySelector('.countries-select input');
        countriesSelect.addEventListener('input', function (val) {
          var unm = countriesSelect.value.length;
          var max = 20;
          if (unm > max) {
            countriesSelect.value = countriesSelect.value.substring(0, max);
            _this4.$message.error('最多可以输入' + max + '字符');
          }
        });
      });
    },
    getJudgeInfo: function getJudgeInfo() {
      var data = this.itemData;
      var unitsStatus = data.units === '' || data.units !== '' && this.rules.units === data.units;
      var specsStatus = data.specs === '' || data.specs !== '' && this.rules.specs === data.specs;
      var factoryStatus = data.factory === '' || data.factory !== '' && this.rules.factory === data.factory;
      return unitsStatus && specsStatus && factoryStatus;
    }
  }
};